module.exports = [{
      plugin: require('E:/Websites/phone-revealer/node_modules/gatsby-plugin-emotion/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('E:/Websites/phone-revealer/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('E:/Websites/phone-revealer/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
